import { createSlice } from '@reduxjs/toolkit';
import { BuyOrderExtraServiceFees } from '../buy-process-form/buy-process-form-types';
import { fetchConfigFees } from './app-api';

export interface ConfigurationStoreState {
  fees: BuyOrderExtraServiceFees;
  hasWarnedMobile: boolean;
}

const initialStateConfiguration: ConfigurationStoreState = {
  fees: {
    beneficalFee: 0,
    nameReviewFee: 0,
    taxHelpFee: 0,
  },
  hasWarnedMobile: false,
};

const configSlice = createSlice({
  name: 'configuration',
  initialState: initialStateConfiguration,
  reducers: {
    warnMobile(state) {
      state.hasWarnedMobile = true;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchConfigFees.fulfilled, (state, action) => {
      state.fees = action.payload;
    });
  },
});

export const { warnMobile } = configSlice.actions;
export const configurationReducer = configSlice.reducer;
